import { NO_INTERNET_CONNECTION } from './toasters';

export const errorMessages = {
  account_disabled: username => `Account with username ${username} is disabled !`,
  badSession:
    'You session is not valid because of another authentication from IP {1} at {2}',
  captcha_error: 'Captcha verification error !',
  database_error: 'Database error / Internal error !',
  document_not_found: (account, params) =>
    `${account} not found! params: ${JSON.stringify(params)} !`,
  duplicate_document: 'Record already exists.',
  duplicate_document: transactionId =>
    'Document with the provided parameters already exists.',
  external_login_error: 'External login request failed !',
  forsePasswordChange: 'You are forced to change password',
  hierarchy_permission_error: 'Account is not in requester`s subtree!',
  incorrect_password: 'Wrong password!',
  internal_error: 'Internal Server Error',
  invalid_date: dateFrom => `Invalid date parameter ${dateFrom}!`,
  invalid_input: bankAccountNumber => `Invalid parameter ${bankAccountNumber}!`,
  invalid_numeric: accountId => `Invalid parameter ${accountId}! It must be numeric!`,
  invalid_string_alphanumeric: (username, from = 2, to = 32) =>
    `Invalid parameter ${username}! It must be between ${from} and ${to} alphanumeric characters!`,
  invalid_token: () => 'Token is expired or invalid!',
  invalid_transaction_type: badTransactionType =>
    'Passed transaction type/types are incorrect.',
  invalid_url: 'Invalid Url!',
  low_balance: currency => 'Insufficient balance for new transaction.',
  missing_parameter: skinId => `Missing ${skinId} parameter!`,
  missing_token: 'No token provided!',
  movement_limit: currency => 'Transaction amount is higher then allowed limit.',
  notAcceptable: 'Request is not acceptable',
  permission_denied: 'The requester doesn`t have permission to use this Api!',
  public_api: 'Public Api !',
  request_completed: 'Request has been already confirmed',
  request_status_pending: 'Request has a pending status',
  service_not_available: serviceName => 'Service not available',
  successful_transaction_request: 'Transaction processed',
  third_party_error: 'Error on sending third party request.',
  transaction_not_allowed: '{0} transaction not allowed. Transaction {reason}.',
  unprocessable_entity: (account, nationalId) => `${account} has no ${nationalId}`,
  verification_expired: 'Verification Expired !',
  [NO_INTERNET_CONNECTION]: 'There is no internet connection',
  'Join id is missing or invalid': 'Join id is missing or invalid',
  'Match configurations are not same as provided seatDraw.':
    'Match configurations are not same as provided seatDraw.',
};

export const showError = (error, ...rest) =>
  typeof errorMessages[error] === 'function'
    ? errorMessages[error](...rest)
    : errorMessages[error];
